export const osnTop109SIcon = {
  data: `<svg viewBox="0 0 280 210" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5" d="M18.76
183.76C31.92 195.52 50.96 203.08 73.64 203.08C128.8 203.08 160.44 163.04 160.44 106.76C160.44 53.8399 136.64 10.1599
80.08 10.1599C37.52 10.1599 8.39999 37.8799 8.39999 74.2799C8.39999 114.04 38.64 134.76 72.24 134.76C92.68 134.76
111.44 123.28 120.4 110.68V114.6C120.4 142.88 103.6 168.36 73.64 168.36C57.12 168.36 46.48 163.32 36.4 154.08L18.76
183.76ZM119.84 83.7999C111.16 94.7199 97.44 101.16 83.44 101.16C65.52 101.16 49 92.4799 49 72.5999C49 59.4399 60.48
44.5999 81.76 44.5999C108.36 44.5999 118.44 65.8799 119.84 83.7999Z" fill="#0F0125" stroke="currentColor"
stroke-width="9.28571"/></svg>`,
  name: 'top-10-9-s',
};
